export const default_debt_info_account = {
  id: "", // Must be populated by generate_id
  // `owners` is the list of borrower indices responsible for this debt (as
  // strings, e.g. ["0", "1"]). One owner = sole; two or more = joint. This is
  // what a MISMO file expresses as one arc per owner, and it scales to the 4
  // borrowers a loan can carry. `borrower` is kept as the PRIMARY owner
  // (owners[0]) for backward compatibility with saved files, the table
  // display, DTI math and the FNM export, all of which read `borrower`.
  owners: [],
  // Properties this mortgage/lien is secured by (a blanket mortgage can cover
  // several). Stored as stable property keys — see constants/property_list.
  // Drives the MISMO ASSET_IsAssociatedWith_LIABILITY arc.
  attached_properties: [],
  // Lien position against the property (1st/2nd/3rd/Other Lien) — see
  // constants/lien_positions. Set for mortgage/lien types; blank otherwise.
  lien_position: "",
  borrower: "",
  liability_type: "",
  description: "",
  account_number: "",
  monthly_payment: "0.00",
  current_balance: "0.00",
  high_credit_limit: "0.00"
};

export const default_debt_info_residence = {
  id: "", // Must be populated by generate_id
  address: "",
  principal_balance: "0",
  first_mortgage: "0.00",
  second_mortgage: "0.00",
  taxes: "0.00",
  insurance: "0.00",
  hoa: "0.00",
  reserves: "2"
};